/**
 * Car QR payloads are newline-separated fields (see trackside format).
 * Tyre-only QR payloads are plain serial strings (numeric or alphanumeric).
 */

/**
 * @param {string} data
 * @returns {{ startNumber: number, driverName?: string, nat?: string, teamName?: string, vehicle?: string, side?: string, location?: string } | string}
 */
export function parseCarQrData(data) {
  const [url, startNumber, driverName, nat, teamName, vehicle, side, location] = String(data).split('\n');

  if (parseInt(startNumber, 10) > 0) {
    return {
      startNumber: parseInt(startNumber, 10),
      driverName,
      nat,
      teamName,
      vehicle,
      side,
      location
    };
  }

  return data;
}

/**
 * @param {unknown} parsed — result of {@link parseCarQrData}
 * @returns {boolean}
 */
export function isCarQrPayload(parsed) {
  return typeof parsed === 'object' && parsed != null && Number(parsed.startNumber) > 0;
}

/** Unscanned wheel labels (PRD-style LF/RF/LR/RR chips). */
const WHEEL_CORNER_LABELS = new Set(['LF', 'RF', 'LR', 'RR']);

/**
 * @param {string} s
 * @returns {boolean}
 */
export function isWheelPlaceholderText(s) {
  const t = String(s ?? '').trim();

  if (!t || t === 'Click & Scan') {
    return true;
  }

  return WHEEL_CORNER_LABELS.has(t);
}

/**
 * @param {string} html — wheel button innerHTML after scan
 * @returns {boolean}
 */
export function hasMeaningfulTyreSerial(html) {
  const s = String(html ?? '').trim();

  if (isWheelPlaceholderText(s)) {
    return false;
  }

  if (s === 'X') {
    return false;
  }

  if (/^\d+$/u.test(s)) {
    return parseInt(s, 10) > 0;
  }

  return true;
}
